export enum CleverTapEventsFees {
  webDiscountTipsFeesEditTipsChoices = 'Web_Discount_Tips_Fees_Edit_Tips_Choices',
  webDiscountTipsFeesEditSignatureConfig = 'Web_Discount_Tips_Fees_Edit_Signature_Config',
  webDiscountTipsFeesEditServiceFeeConfig = 'Web_Discount_Tips_Fees_Edit_Service_Fee_Config',
  webDiscountTipsFeesUpdateReviewLink = 'Web_Discount_Tips_Fees_Update_Review_Link'
}
export enum SettingsCleverTapEvents {
  webSettingsClick = 'Web_Settings_Click',
  webSettingsCommissionCalculationExampleView = 'Web_Settings_Commission_Calculation_Example_View',
  webSettingsCommissionDuplicateRuleClick = 'Web_Settings_Commission_Duplicate_Rule_Click',
  webSettingsCommissionRuleEdited = 'Web_Settings_Commission_Rule_Edited',
  webSettingsExternalCompanyStatusChange = 'Web_Settings_External_Company_Status_Change',
  webSettingsExternalCompanyEdited = 'Web_Settings_External_Company_Edited',
  webSettingsTaxForms = 'Web_Settings_Tax_Forms'
}

export type TaxFormsCleverTapAction = 'page_viewed' | 'download_success' | 'download_failed';

export type TaxFormsCleverTapPageViewStatus = 'did_not_complete_tax_year' | 'no_qualify' | 'qualify';

export type TaxFormsCleverTapEventParams = {
  action: TaxFormsCleverTapAction;
  fiscalYear?: string;
  status?: TaxFormsCleverTapPageViewStatus;
};
